// TODO: Make this file generic and improve logic
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import AppConstants from '../../_Constants/AppConstants';
import Acoustic from './Acoustic';
import Automotive from './Automotive';

/**
 * Returns Customized Scenario options based on selected testSuite and scenarioType
 * @return subScenario UI
 */
class CustomScenarioOptions extends PureComponent {
  static propTypes = {
    testSuite: PropTypes.string.isRequired,
    params: PropTypes.object.isRequired
  }

  getCustomScenarioOptions() {
    const { testSuite, params } = this.props;
    const { selectedScenario: { scenarioType }, labsInAccount } = params;
    // Note: Removed other legacy tests from the options
    if (testSuite === AppConstants.TEST_SUITES.ACOUSTIC.ID) {
      return (
        <Acoustic params={{
          selectedScenario: params.selectedScenario,
          selectedScenarioCallBack: params.selectedScenarioCallBack,
          selectedScenarioError: params.selectedScenarioError,
          scenarioErrorCallBack: params.scenarioErrorCallBack,
          otherParams: params.otherParams, // TODO: only pass deviceMapping there
          updateOtherParamsCallBack: params.updateOtherParamsCallBack,
          whitelistedCustomerIds: params.whitelistedCustomerIds,
          dutsInUse: params.dutsInUse,
          updateNewRunStateParameterCallBack: params.updateNewRunStateParameterCallBack,
          primaryDSNSelected: params.primaryDSNSelected,
          lockFields: params.lockFields
        }} />
      );
    } else if (testSuite === AppConstants.TEST_SUITES.AUTOMOTIVE.ID) {
      return (
        <Automotive params={{
          selectedScenario: params.selectedScenario,
          selectedScenarioCallBack: params.selectedScenarioCallBack,
          selectedScenarioError: params.selectedScenarioError,
          scenarioErrorCallBack: params.scenarioErrorCallBack,
          otherParams: params.otherParams, // TODO: only pass deviceMapping there
          updateOtherParamsCallBack: params.updateOtherParamsCallBack,
          whitelistedCustomerIds: params.whitelistedCustomerIds,
          dutsInUse: params.dutsInUse,
          updateNewRunStateParameterCallBack: params.updateNewRunStateParameterCallBack,
          primaryDSNSelected: params.primaryDSNSelected,
          lockFields: params.lockFields
        }} />
      );
    }
  }

  render() {
    const { selectedScenario } = this.props.params;

    if (!selectedScenario.scenarioType) return (<div></div>);

    return (
      <div>{this.getCustomScenarioOptions()}</div>
    );
  }
}

export default CustomScenarioOptions;
